import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";

export const WA_NUMBER = "525528980641";
export const WA_DISPLAY = "+52 55 2898 0641";
export const WA_LINK = `https://wa.me/${WA_NUMBER}`;
const MESSAGE = encodeURIComponent("Hola, quiero conocer más sobre Cometa y descubrir cuál es mi utopía.");
const FRASES = ["Escríbenos", "¿Cuál es tu utopía?", "Hablemos", "Te leemos hoy"];

export const WhatsAppButton = () => {
  const [i, setI] = useState(0);
  useEffect(() => { const t = setInterval(() => setI((n) => (n + 1) % FRASES.length), 3200); return () => clearInterval(t); }, []);

  return (
    <motion.a
      href={`${WA_LINK}?text=${MESSAGE}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label={`Escríbenos por WhatsApp al ${WA_DISPLAY}`}
      initial={{ opacity: 0, y: 60, scale: 0.6 }}
      animate={{ opacity: 1, y: [0, -6, 0], scale: 1 }}
      transition={{ opacity: { duration: 0.5, delay: 1 }, scale: { type: "spring", stiffness: 260, damping: 18, delay: 1 }, y: { duration: 3.4, repeat: Infinity, ease: "easeInOut", delay: 1.6 } }}
      whileHover={{ scale: 1.06, rotate: -1.5 }}
      whileTap={{ scale: 0.95 }}
      className="group fixed bottom-4 right-4 md:bottom-6 md:right-6 z-50 flex items-center gap-2 md:gap-3 bg-[#25D366] text-white rounded-full pl-2 pr-5 md:pr-6 py-2 shadow-2xl shadow-[#25D366]/40 hover:bg-[#1ebe5a] transition-colors"
    >
      <span className="relative flex h-12 w-12 md:h-14 md:w-14 items-center justify-center rounded-full bg-white/20">
        <span className="absolute -inset-2 rounded-full border-2 border-[#25D366] animate-ping opacity-40" />
        <span className="absolute inset-0 rounded-full bg-white animate-ping opacity-20" style={{ animationDelay: "0.6s" }} />
        <motion.span animate={{ rotate: [0, -12, 12, -8, 0] }} transition={{ duration: 1.2, repeat: Infinity, repeatDelay: 2.4 }} className="relative">
          <MessageCircle size={30} strokeWidth={2.2} />
        </motion.span>
        <span className="absolute -top-0.5 -right-0.5 h-3.5 w-3.5 rounded-full bg-cometa-dorado border-2 border-[#25D366]" />
      </span>
      <span className="flex flex-col leading-tight overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.span key={i} initial={{ y: 14, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -14, opacity: 0 }} transition={{ duration: 0.35 }} className="text-lg md:text-xl font-bold whitespace-nowrap" data-testid="whatsapp-float-label">{FRASES[i]}</motion.span>
        </AnimatePresence>
        <span className="text-sm md:text-base font-medium opacity-95">por WhatsApp</span>
      </span>
    </motion.a>
  );
};
